import { mediaUrl } from "@/lib/helpers";
import { Link } from "react-router-dom";
import { VerifiedBadge, Flag, Movement } from "./Badges";

export function Sparkline({ data = [], color = "#C99738", width = 88, height = 26 }) {
  if (!data.length) return null;
  const max = Math.max(...data), min = Math.min(...data), span = max - min || 1;
  const pts = data.map((v, i) => `${(i / (data.length - 1)) * width},${((v - min) / span) * (height - 4) + 2}`).join(" ");
  return (
    <svg width={width} height={height} className="overflow-visible" aria-hidden>
      <polyline fill="none" stroke={color} strokeWidth="1.5" points={pts} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}

export function RankingTable({ items = [], period = "7d", compact = false }) {
  return (
    <>
      <div className="hidden md:block overflow-x-auto thin-scroll">
        <table className="data-table w-full" data-testid="ranking-table">
          <thead><tr><th>Rank</th><th>Profile</th><th>Country</th><th>Category</th><th className="text-right">Score</th><th className="text-right">Prev</th><th className="text-right">Movement</th><th>Trend</th>{!compact && <th>Period</th>}</tr></thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.slug} data-testid={`ranking-row-${r.slug}`} className="hover:bg-stone/60 transition-colors">
                <td className="font-serif text-lg font-semibold text-ink">#{r.rank}</td>
                <td>
                  <Link to={r.link || `/registry/${r.slug}`} className="flex items-center gap-3 group">
                    <img src={mediaUrl(r.image)} alt="" className="w-9 h-9 rounded-sm object-cover" loading="lazy" />
                    <span><span className="font-medium text-ink group-hover:text-bordeaux transition-colors inline-flex items-center gap-1.5">{r.name} <VerifiedBadge status={r.verification_status} compact /></span>{r.subtitle && <span className="block text-[11px] text-[#6B675F]">{r.subtitle}</span>}</span>
                  </Link>
                </td>
                <td><Flag code={r.country_code} name={r.country} /></td>
                <td className="text-charcoal">{r.category}</td>
                <td className="text-right font-semibold tabular-nums">{r.score?.toFixed(1)}</td>
                <td className="text-right text-[#6B675F] tabular-nums">#{r.previous_rank}</td>
                <td className="text-right"><Movement value={r.movement} /></td>
                <td><Sparkline data={(r.sparkline || []).map((v) => -v)} /></td>
                {!compact && <td className="text-xs text-[#6B675F] uppercase">{period}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="md:hidden space-y-2">
        {items.map((r) => (
          <Link key={r.slug} to={r.link || `/registry/${r.slug}`} data-testid={`ranking-card-${r.slug}`} className="wei-card p-3 flex items-center gap-3">
            <span className="font-serif text-xl font-semibold w-10">#{r.rank}</span>
            <img src={mediaUrl(r.image)} alt="" className="w-10 h-10 rounded-sm object-cover" />
            <div className="min-w-0 flex-1">
              <div className="font-medium text-sm truncate inline-flex items-center gap-1">{r.name} <VerifiedBadge status={r.verification_status} compact /></div>
              <div className="text-[11px] text-charcoal">{r.country} · {r.category}</div>
            </div>
            <div className="text-right"><div className="font-semibold text-sm tabular-nums">{r.score?.toFixed(1)}</div><Movement value={r.movement} /></div>
          </Link>
        ))}
      </div>
    </>
  );
}
